module.exports = __webpack_public_path__ + "img/clipboard-list.833d0cbc.svg";